export default __webpack_public_path__ + "static/media/paid.6d078225.svg";